/**
 * Hooks Module
 * Exports all custom hooks for the purchase flow
 */

// Navigation
export { useNavigation } from './useNavigation';
export type { UseNavigationResult, UseNavigationOptions } from './useNavigation';

// Payment data management
export { usePaymentData } from './usePaymentData';
export type { UsePaymentDataOptions } from './usePaymentData';

// Event handlers
export { usePurchaseFlowHandlers } from './usePurchaseFlowHandlers';
export type { UsePurchaseFlowHandlersResult } from './usePurchaseFlowHandlers';

// Re-export FetchDataParams from types (used by multiple hooks)
export type { FetchDataParams } from '../types';

// Mobile app integration
export { useNativeBackButton } from './useNativeBackButton';

// PAYG (Pay-As-You-Go) validation
export { usePaygValidation } from './usePaygValidation';

// Setup action (shared by PurchaseDetailsScreen and PaymentMethodsListScreen)
export { useSetupAction } from './useSetupAction';

// Charge processing state management
export { useChargeProcessing } from './useChargeProcessing';

// Processor callbacks
export { useProcessorCallbacks } from './useProcessorCallbacks';
export type { UseProcessorCallbacksReturn, ProcessorCallbacks, ProcessingScreenCallbacks } from './useProcessorCallbacks';

// Async payment support resolution
export { usePaymentSupport, useVisibleKinds } from './usePaymentSupport';

// Synchronous state reset on value change (React "adjust state during render" pattern)
export { useResetOnChange } from './useResetOnChange';

// Affiliate promo slots (banner + footer)
export { useAffiliatePromoSlots } from './useAffiliatePromoSlots';
export type { AffiliatePromoSlotsParams, AffiliatePromoSlots } from './useAffiliatePromoSlots';

// Core hook (state + effects + handlers for PurchaseFlowContent)
export { usePurchaseFlowCore } from './usePurchaseFlowCore';
export type { UsePurchaseFlowCoreReturn, HeaderConfig } from './usePurchaseFlowCore';
